// Custom Google OAuth — white-labeled "Sign in to TruBeauté" consent
// screen using the founder's own Google Cloud OAuth client (replaces the
// old Emergent-managed auth.emergentagent.com flow).
//
// Flow: startGoogleLogin() → Google consent page → Google redirects back
// to {origin}/auth/google?code=...&state=... → AuthCallback.jsx exchanges
// the code via POST /api/auth/google (the client_secret never ships to
// the browser).
//
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { safeSession } from "./safeStorage";

const GOOGLE_AUTH_URL = "https://accounts.google.com/o/oauth2/v2/auth";

export const GOOGLE_STATE_KEY = "trubeaute.gauth.state.v1";
export const GOOGLE_RETURN_KEY = "trubeaute.gauth.return.v1";

// Must EXACTLY match an "Authorized redirect URI" registered in the
// Google Cloud Console OAuth client, or Google rejects the consent
// request with `redirect_uri_mismatch`.
export const googleRedirectUri = () => window.location.origin + "/auth/google";

const randomState = () => {
  try {
    return window.crypto.randomUUID();
  } catch {
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  }
};

/**
 * Kick off the Google sign-in round-trip.
 * @param {string} returnTo in-app path to land on after auth completes.
 */
export function startGoogleLogin(returnTo = "/my-routines") {
  const state = randomState();
  // Round-trip CSRF token + the post-login destination. safeSession
  // no-ops when sessionStorage is unavailable; AuthCallback degrades
  // gracefully in that case.
  safeSession.setItem(GOOGLE_STATE_KEY, state);
  safeSession.setItem(GOOGLE_RETURN_KEY, returnTo);
  const params = new URLSearchParams({
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    redirect_uri: googleRedirectUri(),
    response_type: "code",
    scope: "openid email profile",
    state,
    // Always show the account chooser — supports users with multiple
    // Google accounts and avoids silently reusing the wrong one.
    prompt: "select_account",
  });
  window.location.href = `${GOOGLE_AUTH_URL}?${params.toString()}`;
}
